"use client";

import { SignIn } from "@clerk/nextjs";
import { usePathname } from "next/navigation";
import { PiArrowClockwise } from "react-icons/pi";

import { PAGES } from "@/configs/pages.config";
import { buildFilesRedirectPath } from "@/lib/auth-redirect";
import { DEFAULT_LOCALE, getLocaleFromPathname } from "@/lib/i18n/locales";
import { withSeoLocalePath } from "@/lib/i18n/seo-paths";

import AuthPageShell from "./auth-page-shell";

type LoginPageContentProps = {
  trialLinkClaimToken?: string;
  fileUrl?: string;
  redirectUrl?: string;
};

export default function LoginPageContent(props: LoginPageContentProps) {
  const pathname = usePathname();
  const locale = pathname ? getLocaleFromPathname(pathname) : DEFAULT_LOCALE;
  const authPath = withSeoLocalePath(locale, PAGES.LOGIN.PATH);
  const redirectPath =
    props.redirectUrl ??
    buildFilesRedirectPath({
      trialLinkClaimToken: props.trialLinkClaimToken,
      fileUrl: props.fileUrl,
    });

  return (
    <AuthPageShell page="login" fileUrl={props.fileUrl}>
      <SignIn
        appearance={{ elements: { headerSubtitle: { alignSelf: "center" }, formButtonPrimary: { backgroundColor: "#3082cf" } } }}
        routing="path"
        path={authPath}
        forceRedirectUrl={redirectPath}
        fallbackRedirectUrl={redirectPath}
        signUpUrl={withSeoLocalePath(locale, PAGES.SIGN_UP.PATH)}
        fallback={
          <div className="flex items-center justify-center rounded-[1.75rem] border border-gray-200 bg-white px-6 py-10 shadow-sm">
            <div className="flex items-center gap-3 text-sm text-gray-600">
              <PiArrowClockwise className="h-5 w-5 animate-spin text-primary" />
              Loading sign in...
            </div>
          </div>
        }
      />
    </AuthPageShell>
  );
}
